import { Provinces } from 'modules/Address/models/provinces';

export const isNavarraProvince = (province?: keyof Provinces) =>
  province === 'ES-NA';
